import { useState } from "react";
import Image from "next/image";
import { ssURL } from "client/clientAxios";
import NewModal from "components/Shared/NewModal/NewModal";

const ModalTagihan = ({
  isModalTagihanOpen,
  setIsModalTagihanOpen,
  tagihanData = {},
}) => {
  const { pembayaran: listTagihan = [] } = tagihanData || {};
  const unpaidTagihan = listTagihan.filter(
    (tagihan) => tagihan?.status === "belum lunas"
  );
  const [isLoading, setIsLoading] = useState(false);

  const handleBayarSekarang = () => {
    setIsLoading(true);
    setTimeout(() => {
      console.log("Navigasi ke halaman tagihan");
      window.location.href = `${ssURL}/tagihan`;
      setIsModalTagihanOpen(false);
      setIsLoading(false);
    }, 100);
  };

  return (
    <NewModal
      modalId="modalTagihan2"
      modalSize="lg"
      removeFooter={true}
      isModalWhite={true}
      content={
        <>
          <h4 className="fw-extrabold text-center color-dark mb-4">
            Pemberitahuan Tagihan
          </h4>
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-6 col-sm-8">
              <Image
                src={`/img/ilustrasi-pembayaran.png`}
                alt="illustration"
                className="img-fluid mb-4"
                width={0}
                height={0}
                unoptimized
                priority
                style={{ width: "auto", height: "auto" }}
              />
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-8 text-center mb-4">
              <h6 className="fs-18-ss md-fs-6 mb-4 fw-bold color-dark">
                Kami mencatat bahwa kamu belum melakukan pembayaran sesuai jadwal.
              </h6>
              <p className="fw-semibold text-center md-fs-14-ss text-start mb-0">
                <span className="fw-extrabold color-primary">
                  Untuk menghindari gangguan pada layanan Smarteschool, mohon
                  segera selesaikan pembayaran.
                </span>
              </p>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8">
              {isLoading ? (
                <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <button
                  className="btn btn-primary btn-ss btn-primary-ss rounded-ss w-100 fw-bold fs-18-ss shadow-primary-ss mb-4"
                  onClick={handleBayarSekarang}
                >
                  Bayar Sekarang
                </button>
              )}
            </div>
          </div>
        </>
      }
    />
  );
};

export default ModalTagihan;